import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=0b55940c&scoped=true&lang=pug"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"
import style0 from "./Partners.vue?vue&type=style&index=0&id=0b55940c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b55940c",
  null
  
)

export default component.exports